import ContentCenter from "../../ui/ContentCenter";
import { FingerSkillsIntroBanner } from "./FingerSkills";
import React, { useEffect, useState } from "react";
import PlayButton from "../../ui/PlayButton";
import Timer from "../../ui/Timer";

const GESTURE_COUNT = 12;
export default ({ level }: any) => {
  const [gestures, setGestures] = useState<number>(0);
  const [gesturePictures, setGesturePictures] = useState<any>(
    Array.from(Array(GESTURE_COUNT)).map((i, index) => index + 1)
  );
  const [pause, setPause] = useState<boolean>(false);
  const [currentGesture, setCurrentGesture] = useState<number>(0);
  const [preview, showPreview] = useState(false);
  const [ended, setEnded] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [time, setTime] = useState(5000);

  const nextGesture = () => {
    setCurrentGesture(currentGesture + 1);
    showPreview(false);
    setPause(false);
  };

  const restart = (n: number) => {
    setEnded(false);
    setPause(false);
    setGestures(n);
    setCurrentGesture(0);
    const shuffledGestures = gesturePictures.sort(() => {
      return Math.random() > 0.5;
    });
    setGesturePictures(shuffledGestures);
  };

  useEffect(() => {
    if (time < 1000 || level === 1) return;
    const timer = setTimeout(() => setTime(time - 1000), 1000);
    return () => clearTimeout(timer);
  }, [time]);

  useEffect(() => {
    if (level === 3) {
      return;
    }
    showPreview(false);
    if (!gestures) {
      return;
    }

    const timer = setTimeout(() => {
      setPause(true);
      setShowTimer(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [gestures, currentGesture]);

  useEffect(() => {
    setShowTimer(true);
    setTime(5000);
  },[currentGesture]);

  useEffect(() => {
    if (level !== 3) {
      return;
    }
    if (!gestures) {
      return;
    }

    if (currentGesture === gestures) {
      setPause(true);
      return;
    }

    const timer = setTimeout(() => {
      setCurrentGesture(currentGesture + 1);
      showPreview(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [gestures, currentGesture]);

  const end = () => {
    setEnded(true);
  };

  if (!gestures) {
    return (
      <ContentCenter column style={{ height: "100%" }}>
        <FingerSkillsIntroBanner></FingerSkillsIntroBanner>
        {level === 3 ? (
          <PlayButton onClick={() => setGestures(2)}>
            Zwei Gebärden anzeigen
          </PlayButton>
        ) : (
          <></>
        )}
        <PlayButton onClick={() => setGestures(3)}>
          Drei Gebärden anzeigen
        </PlayButton>
        <PlayButton onClick={() => setGestures(4)}>
          Vier Gebärden anzeigen
        </PlayButton>
        <PlayButton onClick={() => setGestures(5)}>
          Fünf Gebärden anzeigen
        </PlayButton>
      </ContentCenter>
    );
  }

  if ((level !== 3 || ended) && currentGesture === gestures) {
    return (
      <ContentCenter column style={{ height: "100%" }}>
        <p>Möchten Sie diese Aufgabe wiederholen?</p>
        {level === 3 ? (
          <PlayButton onClick={() => restart(2)}>
            Zwei Gebärden anzeigen
          </PlayButton>
        ) : (
          <></>
        )}
        <PlayButton onClick={() => restart(3)}>
          Drei Gebärden anzeigen
        </PlayButton>
        <PlayButton onClick={() => restart(4)}>
          Vier Gebärden anzeigen
        </PlayButton>
        <PlayButton onClick={() => restart(5)}>
          Fünf Gebärden anzeigen
        </PlayButton>
      </ContentCenter>
    );
  }

  if (level === 1) {
    return (
      <ContentCenter column style={{ height: "100%" }}>
        <img
          src={
            "/fingerskills/gesture/" +
            gesturePictures[currentGesture + 1] +
            ".png"
          }
          height={164}
        />
        <PlayButton onClick={() => setCurrentGesture(currentGesture + 1)}>
          Weiter
        </PlayButton>
      </ContentCenter>
    );
  }

  if (level === 2) {
    if (pause) {
      return (
        <ContentCenter column style={{ height: "100%" }}>
          {preview ? (
            <img
              src={
                "/fingerskills/gesture/" +
                gesturePictures[currentGesture + 1] +
                ".png"
              }
              width={164}
            />

          ) : (
            <></>
          )
          }
          <PlayButton onClick={() => showPreview(true)}>Kontrolle</PlayButton>
          <PlayButton onClick={() => nextGesture()}>Weiter</PlayButton>
        </ContentCenter>
      );
    } else {
      return (
        <ContentCenter column style={{ height: "100%" }}>
          <img
            src={
              "/fingerskills/gesture/" +
              gesturePictures[currentGesture + 1] +
              ".png"
            }
            width={164}
          />
          {showTimer && <Timer time={time}/>}
        </ContentCenter>
      );
    }
  }

  console.log("C: " + currentGesture)
  console.log("G: " + gesturePictures )

  if (level === 3) {
    if (pause) {
      return (
        <ContentCenter column style={{ height: "100%" }}>
          {preview ? (
            <div style={{display: "flex", width: "450px", justifyContent: "center"}}>
            {gesturePictures.map((g: any, index: number) => {
              if (index > currentGesture - gestures && index < currentGesture +1 )
                return <img  width={80} src={`/fingerskills/gesture/${g}.png`}/>;
            })}
            </div>
          ) : (
            <></>
          )}
          <PlayButton onClick={() => showPreview(true)}>Kontrolle</PlayButton>
          <PlayButton onClick={() => end()}>Weiter</PlayButton>
        </ContentCenter>
      );
    } else {
      return (
        <ContentCenter column style={{ height: "100%" }}>
          <img
            src={
              "/fingerskills/gesture/" +
              gesturePictures[currentGesture + 1] +
              ".png"
            }
            width={164}
          />
          {showTimer && <Timer time={time}/>}

        </ContentCenter>
      );
    }
  }

  return <div>Go. Show {gestures}</div>;
};
